import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';

import { AppModule } from './app/app.module';
import { loadCognitoConfig } from './app/core/config/runtime-config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/**
 * Amplify is configured before Angular boots so no component can reach an auth call
 * ahead of it. When the config is unavailable Amplify is deliberately left
 * unconfigured and the app still starts: the public pages keep working and the auth
 * screens surface the reason (see CognitoAuthService), which beats a blank site.
 */
loadCognitoConfig()
  .then((cognito) => {
    if (cognito) {
      Amplify.configure({
        Auth: {
          Cognito: {
            userPoolId: cognito.userPoolId,
            userPoolClientId: cognito.userPoolClientId,
            ...(cognito.oauthDomain && {
              loginWith: {
                oauth: {
                  domain: cognito.oauthDomain,
                  scopes: ['openid', 'email', 'profile'],
                  // Must match the app client's callback / logout URLs exactly.
                  redirectSignIn: [`${window.location.origin}/account/login`],
                  redirectSignOut: [`${window.location.origin}/`],
                  responseType: 'code' as const,
                },
              },
            }),
          },
        },
      });
    }
  })
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch((err) => console.error(err));
